// extracted by mini-css-extract-plugin
export default {"sidebar-wrap":"Sidebar_sidebar-wrap__33KQg","main-content-wrap":"Sidebar_main-content-wrap__wJiHu"};